import React, { useState } from 'react';
import styled from 'styled-components';
import { COLORS, FONTS, Image, ImageEntity, TextBadge } from '@fupa/fupa-uikit';
import { FullscreenImage } from 'app/components/backdrop/FullscreenImage';
const AVATAR_SIZE = 150;
const StyledAvatar = styled.div.withConfig({
  componentId: "sc-17qhwl2-0"
})(["height:", "px;position:relative;width:", "px;cursor:pointer;.avatar{border:1px solid ", ";}"], AVATAR_SIZE, AVATAR_SIZE, COLORS.lighterGrey);
const JerseyNumber = styled(TextBadge).withConfig({
  componentId: "sc-17qhwl2-1"
})(["&&&{width:2.375rem;height:2.375rem;font-size:", ";right:0;z-index:0;}"], FONTS['18']);
export const Avatar = _ref => {
  let {
    image,
    jerseyNumber
  } = _ref;
  const [fullscreen, setFullscreen] = useState(false);
  const handleClose = () => {
    setFullscreen(false);
  };
  const handleOpen = () => {
    setFullscreen(true);
  };
  const JerseyNumberBadge = jerseyNumber ? /*#__PURE__*/React.createElement(JerseyNumber, {
    value: jerseyNumber.toString(),
    position: 1
  }) : null;
  const Photo = image ? /*#__PURE__*/React.createElement(Image, {
    className: 'avatar',
    entity: ImageEntity.Player,
    circle: true,
    src: image,
    ratio: "1:1",
    height: AVATAR_SIZE,
    width: AVATAR_SIZE,
    eager: true,
    fetchPriority: "high"
  }) : null;
  const fullscreenImage = image ? {
    ...image,
    description: image.source ? "Foto: ".concat(image.source) : ''
  } : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledAvatar, {
    onClick: handleOpen,
    "data-sentry-element": "StyledAvatar",
    "data-sentry-source-file": "Avatar.tsx"
  }, JerseyNumberBadge, Photo), /*#__PURE__*/React.createElement(FullscreenImage, {
    entity: "player",
    imageSrc: fullscreenImage,
    onClick: handleClose,
    open: fullscreen,
    "data-sentry-element": "FullscreenImage",
    "data-sentry-source-file": "Avatar.tsx"
  }));
};